export const profitAndLossTransalations = {
  headerText: {
    key: 'profitLoss.headerText',
    defaultValue: 'P & L report based on financial year {{reportPeriod}}.',
  },
  error: {
    errorTitle: {
      key: 'profitLoss.error.errorTitle',
      defaultValue: 'Something went wrong!',
    },
    errorSubtitle: {
      key: 'profitLoss.error.errorSubtitle',
      defaultValue: 'There was an error while fetching the report. Please try again!',
    },
  },
  noData: {
    noDataTitle: {
      key: 'profitLoss.noData.noDataTitle',
      defaultValue: 'No data found for selected filters',
    },
    noDataSubtitle: {
      key: 'profitLoss.noData.noDataSubtitle',
      defaultValue: 'Try selecting a different month or year range.',
    },
  },
  loading: {
    key: 'profitLoss.loading',
    defaultValue: 'Fetching Profit and Loss data...',
  },
  viewDetailsButton: {
    key: 'profitLoss.viewDetailsButton',
    defaultValue: 'View Details',
  },
  monthDropdown: {
    key: 'profitLoss.monthDropdown',
    defaultValue: 'Month',
  },
  yearDropdown: {
    key: 'profitLoss.yearDropdown',
    defaultValue: 'Year',
  },
  profitLossSummary: {
    key: 'profitLoss.profitLossSummary',
    defaultValue: 'Profit/Loss Summary (excl. VAT)',
  },
  totalProfit: {
    key: 'profitLoss.totalProfit',
    defaultValue: 'Total Profit (excl. VAT)',
  },
  totalLoss: {
    key: 'profitLoss.totalLoss',
    defaultValue: 'Total Loss (excl. VAT)',
  },
  revenue: {
    key: 'profitLoss.revenue',
    defaultValue: 'Revenue (excl. VAT)',
  },
  expenses: {
    key: 'profitLoss.expenses',
    defaultValue: 'Expenses (excl. VAT)',
  },
  chartProfitLoss: {
    key: 'profitLoss.chartProfitLoss',
    defaultValue: 'Profit/Loss',
  },
  chartTitle: {
    key: 'profitLoss.chartTitle',
    defaultValue: 'Profit & Loss Overview',
  },
  chartValueProfit: {
    key: 'profitLoss.chartValueProfit',
    defaultValue: 'Profit',
  },
  chartValueLoss: {
    key: 'profitLoss.chartValueLoss',
    defaultValue: 'Loss',
  },
  chartToggleShow: {
    key: 'profitLoss.chartToggleShow',
    defaultValue: 'Show P&L Chart',
  },
  chartToggleHide: {
    key: 'profitLoss.chartToggleHide',
    defaultValue: 'Hide P&L Chart',
  },
  costNames: {
    salesExcVat: {
      key: 'profitLoss.costNames.salesExcVat',
      defaultValue: 'Sales excl. VAT',
    },
    salesIncVat: {
      key: 'profitLoss.costNames.salesIncVat',
      defaultValue: 'Sales incl. VAT',
    },
    otherCosts: {
      key: 'profitLoss.costNames.otherCosts',
      defaultValue: 'Other costs',
    },
    reductions: {
      key: 'profitLoss.costNames.reductions',
      defaultValue: 'Reductions',
    },
    salaries: {
      key: 'profitLoss.costNames.salaries',
      defaultValue: 'Salaries',
    },
    scrapping: {
      key: 'profitLoss.costNames.scrapping',
      defaultValue: 'Scrapping',
    },
    shrinkage: {
      key: 'profitLoss.costNames.shrinkage',
      defaultValue: 'Shrinkage',
    },
    surplus1: {
      key: 'profitLoss.costNames.surplus1',
      defaultValue: 'Surplus1',
    },
    properties: {
      key: 'profitLoss.costNames.properties',
      defaultValue: 'Properties',
    },
  },
  reportProperties: {
    actuals: {
      key: 'profitLoss.reportProperties.actuals',
      defaultValue: 'Actuals',
    },
    indexVsLY: {
      key: 'profitLoss.reportProperties.indexVsLY',
      defaultValue: 'Index vs LY',
    },
    indexVsBudget: {
      key: 'profitLoss.reportProperties.indexVsBudget',
      defaultValue: 'Index vs Budget',
    },
    sob: {
      key: 'profitLoss.reportProperties.sob',
      defaultValue: 'SoB',
    },
    sobLY: {
      key: 'profitLoss.reportProperties.sobLY',
      defaultValue: 'SoB LY',
    },
    sobBudget: {
      key: 'profitLoss.reportProperties.sobBudget',
      defaultValue: 'SoB Budget',
    },
  },
  sortBy: {
    sobAscending: {
      key: 'profitLoss.sortBy.sobAscending',
      defaultValue: 'SoB Lowest',
    },
    sobDescending: {
      key: 'profitLoss.sortBy.sobDescending',
      defaultValue: 'SoB Highest',
    },
  },
  mobileBannerText: {
    key: 'profitLoss.mobileBannerText',
    defaultValue: 'Tilt your phone to landscape mode for better view',
  },
};
